import VueI18n from 'vue-i18n'
import enLocale from './en'
import zhLocale from './zh'
import resourceMessages from './resource'

// pointManagement
import pointManagementEn from './pointManagement/en'
import pointManagementZh from './pointManagement/zh'
// uploadExcel
import uploadExcelEn from './uploadExcel/en'
import uploadExcelZh from './uploadExcel/zh'

// common
import commonEn from './common/en'
import commonZh from './common/zh'

// equipmentManagement
import equipmentManagementEn from './equipmentManagement/en'
import equipmentManagementZh from './equipmentManagement/zh'
// router
import routerEn from './router/en'
import routerZh from './router/zh'
// 工作台
Vue.use(VueI18n)

const messages = {
  en: {
    ...pointManagementEn,
    ...equipmentManagementEn,
    ...routerEn,
    ...commonEn,
    ...uploadExcelEn,
    ...resourceMessages.en,
    ...enLocale,
    ...ELEMENT.lang.en,
  },
  zh: {
    ...pointManagementZh,
    ...equipmentManagementZh,
    ...routerZh,
    ...commonZh,
    ...uploadExcelZh,
    ...resourceMessages.zh,
    ...zhLocale,
    ...ELEMENT.lang.zhCN,
  },
}

const i18n = new VueI18n({
  locale: 'zh', // set locale zh or en
  messages, // set locale messages
  silentTranslationWarn: true,
})

export default i18n
